import * as types from "../actions/visitorTypeTypes";

const initialState = {
    visitorTypes: [],
    loading: false,
    error: null,
    visitorTypeAdded: false,
    
};

const visitorTypesReducer = (state = initialState, action, updatedVisitor) => {
    switch (action.type) {
        case types.FETCH_VISITOR_TYPES_REQUEST:
        case types.ADD_VISITOR_TYPES_REQUEST:
          //console.log("add test");
            return { 
                ...state,
                loading: true,
                error: null,
                visitorTypeAdded: false,
            };


            //FOR FETCHING VISITORS
        case types.FETCH_VISITOR_TYPES_SUCCESS:
            return { 
                ...state, 
                loading: false,
                visitorTypes: action.payload
            };


            //FOR ADDING VISITORS

        case types.ADD_VISITOR_TYPES_SUCCESS:
            ////console.log("reducer"); 
        ////console.log(action.payload);
        ////console.log('ADDED data:', [...state.visitorTypes, action.payload]); 
            return {
              ...state,
              loading: false,
              visitorTypes: action.payload,
              error:null,
              visitorTypeAdded: true
            };

            //for updating visitor types     
              case types.UPDATE_VISITOR_TYPES_REQUEST:
                return {
                  ...state,
                  loading: true,
                  payload: updatedVisitor,
                  error: null
                };
         
              case types.UPDATE_VISITOR_TYPES_SUCCESS:
                ////console.log("Before state update", state); 
                ////console.log("UPDATED VISITOR" , action.payload);
                return {
                  ...state,
                  loading: false,
                  visitorTypes: state.visitorTypes.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                  ),
                };

                //FOR DELETING VISITOR TYPES
                case types.DELETE_VISITOR_TYPES_REQUEST:
                  ////console.log(action.payload)
                  return { 
                      ...state,
                      loading: true,
                      // payload: action.payload 
                  };
  
              case types.DELETE_VISITOR_TYPES_SUCCESS:
                ////console.log("reducer delete VISITOR TYPES", action.payload)
                  ////console.log(action.payload);
                  return {
                    ...state,
                    loading: false,
                    visitorTypes: state.visitorTypes.filter((item) => item.id !== action.payload),
                  };


        case types.FETCH_VISITOR_TYPES_FAILURE:
        case types.ADD_VISITOR_TYPES_FAILURE:
          return { 
            ...state,
             loading: false,
              error: action.payload,
              visitorTypeAdded: false
             };
        case types.UPDATE_VISITOR_TYPES_FAILURE:
          return { 
            ...state,
             loading: false,
              error: action.payload
             };
          case types.DELETE_VISITOR_TYPES_FAILURE:
            return { 
                ...state, 
                loading: false,
                error: action.payload 
            };

        default:
            return state;
    }
};

export default visitorTypesReducer;